<template>
  <b-dropdown class="translate_wrapper ml-2 h-32 menu" :variant="'dark'" size="sm"
    toggle-class="language-button">
    <template slot="button-content">
      <div class="d-flex align-items-center f-16 pl-2 pr-2 " style="position: relative;width: 92%;">
        <!-- <i class="icofont icofont-user f-20"></i> -->
         <img src="https://cdn.adsalecdn.com/EMP/2-0/icons/loginUser.svg?v=1">
        <span class="ml-1 cut-text f-14" style="max-width: 200px;min-width: 90px;text-align: left;">{{ $t('lbl_EMPBE_Greetings') }} {{ user.displayName }}</span>
      </div>
    </template>
    <b-dropdown-item v-if="isAdmin" @click="goToMyAccount" style="padding: 0 !important;">
      <div style="width: 100%; height: 100%; padding: 16px; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
        <div style="width: 20px; height: 20px; position: relative; overflow: hidden">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/Account circle.png" alt="My Account" style="width: 20px; height: 20px; position: absolute;">
        </div>
        <div style="text-box-trim: trim-both; text-box-edge: cap alphabetic; justify-content: center; display: flex; flex-direction: column; color: rgba(0, 0, 0, 0.80); font-size: 16px; font-weight: 600; line-height: 16px; word-wrap: break-word">
          {{ $t("lbl_EMPBE_MyAccount") }}</div>
      </div>
    </b-dropdown-item>
    <b-dropdown-item @click="logout" v-bind:t_label="'EMPBE_Header_Logout'" style="padding: 0 !important;">
      <div style="width: 100%; height: 100%; padding: 16px; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
        <div style="width: 20px; height: 20px; position: relative">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/logout.png" alt="Logout" style="width: 20px; height: 20px; position: absolute;">
        </div>
        <div style="text-box-trim: trim-both; text-box-edge: cap alphabetic; justify-content: center; display: flex; flex-direction: column; color: rgba(0, 0, 0, 0.80); font-size: 16px;  font-weight: 600; line-height: 16px; word-wrap: break-word">
          {{ $t("lbl_EMPBE_Logout") }}</div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>

export default {
  name: 'empProfile',
  computed: {
    user() {
      return this.$store.state.authentication.user
    },
    isAdmin() {
      // 统一使用 userRole 字段判断，只有 admin 或 member 角色才显示 MyAccount
      if (!this.user?.userRole) {
        return false;
      }
      const role = String(this.user.userRole).toLowerCase();
      return role === 'admin' || role === 'member';
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('authentication/logout');
    },
    goToMyAccount: function () {
      this.$router.push({ name: 'MyAccount' });
    },
    getMemberGrade() {
      var currentLangId = localStorage.getItem('currentLangId');
      if (this.user.userType == "ADMIN") {
        return "ADMIN"
      }
      return currentLangId == "950" ? this.user.memberGradeTc : currentLangId == "936" ? this.user.memberGradeSc : currentLangId == "1252" ? this.user.memberGradeEn : ""
    }
  },
};
</script>

<style scoped>
::v-deep .dropdown-menu {
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 8px;
}

::v-deep .dropdown-item {
  padding: 0 !important;
}
</style>
<style>
.menu .dropdown-toggle::after {
    display: inline !important;
    content: "";
    border-top: 0.4em solid;
    border-right: 0.4em solid transparent;
    border-bottom: 0;
    border-left: 0.4em solid transparent;
    position: absolute;
    right: 5px;
    top: 50%;
}</style>
